import logger from 'utils/logger.util';

const L = logger('isNotEnumKey');

const isNotEnumKey = (enumeration, key) => {
  try {
    return !Object.keys(enumeration).includes(key);
  } catch (e) {
    L.warn('()', e);
    return true;
  }
};

// noinspection JSUnusedGlobalSymbols
export default isNotEnumKey;
